/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { TableCell, TableRow } from "@material-ui/core";

const ACCESS_TYPES = {
  view: "View Only",
  full: "Full Access",
  none: "No Access",
};

export default function RoleRow({ role, permissions }) {
  const cellStyle = {
    fontSize: 14,
    fontWeight: 400,
    fontFamily: "ObjectSans-Regular",
  };

  return (
    <TableRow>
      <TableCell
        style={{
          ...cellStyle,
          fontWeight: 500,
          fontFamily: "ObjectSans-Medium",
        }}
      >
        {role.role}
      </TableCell>
      {permissions.map((permission) => {
        const access = role.permissions[permission] || "none";
        return (
          <TableCell
            key={permission}
            style={{
              ...cellStyle,
              color: access === "none" ? "#bdbdbd" : "#000",
              textAlign: "center" as const,
            }}
          >
            {ACCESS_TYPES[access]}
          </TableCell>
        );
      })}
    </TableRow>
  );
}
